import { FC, useEffect, useState } from "react";
import { Collapse, Spin } from "antd";
import african from "@assets/images/african.png";
import asian from "@assets/images/asian.png";
import caucasian from "@assets/images/caucasian.png";
import hispanic from "@assets/images/hispanic.png";
// import others from "@assets/images/others.svg";
//import TransparentIcon from '@assets/Transparent.svg';
import PinUnpin from "@pages/member-details/pin-unpin-component";
// import PentagonCard from "@pages/member-details/social-determinants/ethnicity/pentagon-card";
import CustomTooltip from "@pages/tool-tip";
import './ethnicity.scss'
import { SDAlphabetCard, SDEthnicityCard } from "../card";
import { cloneDeep } from 'lodash'
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";

const { Panel } = Collapse;

const Ethnicity: FC<any> = (props) => {
  const dataCardId = "11";
  const [activeCardPanel, setActiveCardPanel] = useState<any>(props?.activeKey?.includes(dataCardId) ? ["1"] : [])

  useEffect(()=>{
    console.log("Ethnicity.useEffect");
    setActiveCardPanel(props?.activeKey?.includes(dataCardId) ? ["1"] : []);
  }, [props.activeKey])

  const onCollapseChange = () => {
    if(activeCardPanel.length > 0){
      props?.setActivePanels(cloneDeep(props?.activeKey)?.filter((item:any) => item !== dataCardId))
    }
    else props?.setActivePanels([...(props?.activeKey ? props?.activeKey : []), dataCardId]);
  }

  const genExtra = (id:any) => <PinUnpin marginRight={"16px"} dataCardId={id} changeHandler={props?.pinChangeHandler}
  pinCardIds={props.pinCardIds}/>

  const getHeading = (headerValue: any) => (
    <>
      <span>{headerValue}</span>
      <CustomTooltip
        toolTipvalue={headerValue}
        children={
          <span
            style={{ margin: "8px" }}
            className="icon icon-info clr-lightGrayColor"
          ></span>
        }
      />
    </>
  );

  return (
    <Collapse accordion activeKey={activeCardPanel} expandIconPosition="right" bordered={false} onChange={onCollapseChange}>
      <Panel className="title ui-ethnicity" header={getHeading("Language / Ethnicity")} key="1" extra={genExtra(dataCardId)} style={{ marginBottom: "8px" }}>
        <Spin spinning={props.loading} indicator={<HealthemSpinner size={50} />}>
          <div className="ui-ethnicity__card-items">
            <SDAlphabetCard title="Member Speaks English 'Very Well'" value={`${props?.data?.memberSpeaksEnglishVeryWell || 0}`} />
            <SDEthnicityCard
              title="Neighborhood Ethnicity"
              items={[
                {
                  image: <img src={caucasian} alt="caucasian" />,
                  color: "#807af4",
                  name: "White/Caucasian",
                  percentage: props?.data?.neighborhoodEthnicity?.whiteAndCaucasian || 0,
                },
                {
                  image: <img src={hispanic} alt="hispanic" />,
                  color: "#88bbbf",
                  name: "Hispanic & Others",
                  percentage: props?.data?.neighborhoodEthnicity?.hispanicAndOthers || 0,
                },
                {
                  image: <img src={african} alt="african" />,
                  color: "#ef9b70",
                  name: "African American",
                  percentage: props?.data?.neighborhoodEthnicity?.africanAmerican || 0,
                },
                {
                  image: <img src={asian} alt="asian" />,
                  color: "#e8788f",
                  name: "Asian",
                  percentage: props?.data?.neighborhoodEthnicity?.asian || 0,
                },
              ]}
            />
          </div>
        </Spin>
      </Panel>
    </Collapse>
  );
};

export default Ethnicity;
